import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {toggleLoader} from "../../shared/actions/setting";
import FormHandler from "../../shared/utils/FormHandler";
import FeatherIcon from "feather-icons-react";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import { resetPassword } from "../../utils/mainServices";
import { validateResetPassword } from "../../utils/validation";

const ResetPassword = ({selectedUserData, onClose}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [formErr, setFormErr] = useState("");
  const [showText, setShowText] = useState(false);

  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleOnBlur,
    initForm,
  } = FormHandler(handleResetPassword, validateResetPassword);

  function handleResetPassword() {
    setIsLoading(true);
  }
  

  useEffect(() => {
   if (!isLoading) {
     return;
   }
 
   const handleResetPassword = async () => {
     dispatch(toggleLoader(true));
     try {
       const payload = {
         id: selectedUserData.id,
         password: values.password,
       };

      await resetPassword(payload);
 
       resetForm();
       toast.success("Password changed successfully.");
     } catch (error) {

      if (error.response) {
        if (error.response.status === 422) {
          setFormErr(error.response.data.message);
        } else if (error.response.status === 403) {
          toast.error("You don’t have permission to do this");
        } else {
          console.error('Error during password reset:', error);
          toast.error("Oops... Something went wrong!");
        }
      } else {
        console.error('Error during password reset:', error);
        toast.error("Oops... Something went wrong!");
      }
     } finally {

       setIsLoading(false);
       dispatch(toggleLoader(false));
     }
   };
 
   handleResetPassword();
 }, [isLoading]);
 

  function resetForm() {
    onClose();
    initForm({});
    setFormErr("");
    setShowText(false);
  }

  return (
    <div className={"sa-popup-bg "}>
      <div className="sa-popup">
        <form onSubmit={handleSubmit} className={"sa-modal-box-style"}>
          <div className="sa-popup-header">
            <span className={"sa-model-heading"}>Reset Password</span>
            <div className="sa-popup-close-icon" onClick={resetForm}><FeatherIcon className={"sa-modal-close-icon"}
                                                                                  icon={"x"}/></div>
          </div>
          <div className="sa-popup-content">
            <div className="col-md-6">
              <div className="form-group m-b-16">
                <label htmlFor="password">New Password</label>
                <input type={!showText ? "password" : "text"}
                       className={`form-control ${errors.password && "warning-input"}`}
                       onBlur={handleOnBlur} onChange={handleChange}
                       value={values.password || ''} name="password" id="password"
                       placeholder="Enter your new password"/>
                <span className="field-icon" onClick={() => setShowText(!showText)}><FeatherIcon
                  className="toggle-password" icon={showText ? "eye-off" : "eye"}/></span>
                {errors.password && (<p className="warning-input-msg ">{errors.password}</p>)}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group m-b-16">
                <label htmlFor="confirmPassword">Confirm New Password</label>
                <input type={!showText ? "password" : "text"}
                       className={`form-control ${errors.confirmPassword && "warning-input"}`}
                       onBlur={handleOnBlur} onChange={handleChange}
                       value={values.confirmPassword || ''} name="confirmPassword" id="confirmPassword"
                       placeholder="Retype your new password"/>
                <span className="field-icon" onClick={() => setShowText(!showText)}><FeatherIcon
                  className="toggle-password" icon={showText ? "eye-off" : "eye"}/></span>
                {errors.confirmPassword && (
                  <p className="warning-input-msg ">{errors.confirmPassword}</p>)}
              </div>
            </div>
          </div>
          {formErr && (<div className={"login-warning-msg"}>{formErr}</div>)}
          <div className="sa-popup-btn">
            <button className="sa-popup-secondary-btn-style sa-popup-cancel-btn-style" type="button"
                    onClick={resetForm}>{t("button.CANCEL")}
            </button>
            <button type="submit" className="sa-popup-secondary-btn-style">{t("button.CHANGE", { defaultValue: "Change" })}</button>
          </div>
        </form>
      </div>
    </div>
  )
};

export default ResetPassword;
